import { Col, Image, Row } from 'react-bootstrap';

export default function AlternatingImages({ sections, key }) {
  return sections.map((section, i) => {
    const col_1 = (
      <Col className="alt-img-info d-flex flex-column">
        {section.title && <h3>{section.title}</h3>}
        <div className="spacious-text flex-grow-1">
          {section.description}
        </div>
      </Col>
    );

    const col_2 = (
      <Col className="alt-img-image">
        <Image src={section.image} alt={section.title} style={{ width: '100%' }} />
      </Col>
    );

    return (
      <Row
        key={`${key}-alt-img-row-${i}`}
        xs={1}
        md={2}
        className="align-items-stretch"
      >
        {i % 2 === 0 ? col_1 : col_2}
        {i % 2 === 0 ? col_2 : col_1}
      </Row>
    );
  });
}